// Kapio gradient palette — used as fallback background when a product/store has no image.
// Deterministic: pick by hashing the entity id so the same product always gets the same gradient.
export const gradients = [
  ["#3A5A40", "#4A7A52"],
  ["#8B6F47", "#A0845C"],
  ["#556B2F", "#6B8E23"],
  ["#8B6F47", "#6B4423"],
  ["#2D4A34", "#4A7A52"],
  ["#A0845C", "#8B6F47"],
  ["#6B8E23", "#556B2F"],
  ["#7A6444", "#A0845C"],
];

export function gradientForId(id) {
  if (!id) return gradients[0];
  let h = 0;
  for (let i = 0; i < id.length; i++) h = (h * 31 + id.charCodeAt(i)) | 0;
  return gradients[Math.abs(h) % gradients.length];
}
